import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { type UsersEventsSortBy } from '../../domain/models/engagement-users'

export class GetUsersEventsQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly fromPrevious: string,
    private readonly toPrevious: string,
    private readonly sortBy: UsersEventsSortBy,
    private readonly sortOrder: 'asc' | 'desc',
    private readonly offset: number,
    private readonly limit: number,
    private readonly organization: string
  ) {
    super(ApiEndpoint.UsersEvents)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      from_previous: this.fromPrevious,
      to_previous: this.toPrevious,
      sort_by: this.sortBy,
      sort_order: this.sortOrder,
      offset: this.offset,
      limit: this.limit,
      organization: this.organization
    }
  }
}
